// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__G3QRW","input":"styles_input__OeyG5","checkmark":"styles_checkmark__nTWX0"};